import React from "react";
// import "./_css/index.css"
// import "./_css/minos.css"
// import "./_font/minos/Helvetica.otf";
// import "./_font/minos/NotoSansTC-Bold.otf";
// import "./_font/minos/NotoSansTC-Regular.otf";
// import "./_font/minos/ZabalDEMO-Bold.otf";
// import "./_font/minos/ZabalDEMO-ExtraBold.otf";
// import "./_font/minos/ZabalDEMO-Light.otf";
// import "./_font/minos/ZabalDEMO-SemiBold.otf";

import ReactDOM from "react-dom/client";
import App from "./App";
import {HashRouter as Router, BrowserRouter } from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <App />
  </Router>
);
